import { formatDistanceToNow } from 'date-fns';

import type { SkillCommand } from '../../../../lib/skill-constants';
import type { CustomSkillRecord } from '../../../../queries/chats';

export const ALL_CUSTOM_SKILL_FILTERS = { enabled: [true, false], includeDrafts: true };
export const GENERATE_AI_SUMMARIES = true;

export type CustomSkillManagementTab = 'my-skills' | 'wtw-skills' | 'shared-with-me';

export type PendingSkillAction = {
  type: 'toggle' | 'delete' | 'publish';
  uuid: string;
};

export function getUpdatedLabel(updatedAt: string) {
  return formatDistanceToNow(new Date(updatedAt), { addSuffix: true });
}

export function getCustomSkillDisplayText(...values: Array<string | null | undefined>) {
  for (const value of values) {
    const trimmedValue = value?.trim();
    if (trimmedValue) {
      return trimmedValue;
    }
  }

  return 'No description provided.';
}

export function getSharedSkillOwnerName(skill: CustomSkillRecord): string | null {
  if (!('owner' in skill) || !skill.owner) return null;

  const name = [skill.owner.firstName?.trim(), skill.owner.lastName?.trim()].filter(Boolean).join(' ');
  return name || skill.owner.email?.trim() || null;
}

export function getSharedSkillAttribution(skill: CustomSkillRecord): string {
  return `Shared with you by ${getSharedSkillOwnerName(skill) ?? 'Unknown'}`;
}

export function getRootCustomSkillUuid(skill: CustomSkillRecord) {
  return skill.draftOfCustomSkillUuid ?? skill.uuid;
}

export function hasUnpublishedChanges(skill: CustomSkillRecord) {
  return Boolean(skill.draftOfCustomSkillUuid);
}

export function isBuiltInSkillCommand(command: SkillCommand) {
  const source = command.skill?.source;
  return Boolean(source) && source !== 'personal' && source !== 'shared';
}

export function sortCustomSkills(skills: CustomSkillRecord[]) {
  return [...skills].sort((left, right) => {
    return new Date(right.updatedAt).getTime() - new Date(left.updatedAt).getTime();
  });
}
